import type { NavImpactSurfaces } from '../AutotestNavImpactStats';

export const spec = (): Partial<NavImpactSurfaces> => ({
  statStyle: 'trend_icon',
  statLayout: 'inline',
});
